// extracted by mini-css-extract-plugin
export default {"root":"j1Y_aa"};